__turbopack_context__.v({
  "root": "AuthSection-module-scss-module__Wi5Jqa__root",
  "signIn": "AuthSection-module-scss-module__Wi5Jqa__signIn",
  "signUp": "AuthSection-module-scss-module__Wi5Jqa__signUp",
  "signUpContainer": "AuthSection-module-scss-module__Wi5Jqa__signUpContainer",
});
